import React from 'react'
import { HomeRails } from '../home-rails'
import { HomeContentCard } from '../home-content-card'
import { HOME_SECTION_TYPE } from './home-sections'

export const QuizRails = ({ quizSection }) => {
  const { items } = quizSection

  return (
    <HomeRails
      title='Ready for a Quiz?'
      dataTest='home-quiz-rails'
      items={items}
      renderItem={(item, itemIndex) => {
        return (
          <HomeContentCard
            content={item}
            dataTest={`home-quiz-${itemIndex}`}
            itemIndex={itemIndex}
            railType={HOME_SECTION_TYPE.QUIZ}
          />
        )
      }}
    />
  )
}
